/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {unsubscribeFromIncident} from '../api'

export const useMutationUnsubscribeFromIncident = createReactQueryMutationHook('unsubscribeFromIncident', unsubscribeFromIncident)
